import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import SerieNotaFiscalService from "service/fiscal/SerieNotaFiscalService";
import { filterApplyTemplate, TextMatchModeOptions } from "utils/filterUtils";

const serieNotaFiscalService = new SerieNotaFiscalService();

export default function SerieNotaFiscalListagem() {
    const defaultFilters: DataTableFilterMeta = {
        descricao: { constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }], operator: FilterOperator.AND }
    };

    return (
        <BaseListagem ordenacao="numeroSerie,ASC" service={serieNotaFiscalService} urlService="/serieNotaFiscal"
            tituloPagina="Séries de nota fiscal" defaultFilters={defaultFilters} showClearFilterButton nome="serieNotaFiscal">
            <Column field="numeroSerie" header="Série" />
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="modelo" header="Modelo" body={(rowData) => serieNotaFiscalService.getModelo(rowData.modelo)} />
            <Column field="ambiente" header="Ambiente" body={(rowData) => serieNotaFiscalService.getAmbiente(rowData.ambiente)} />
            <Column field="unidadeOrganizacional.nome" header="Unidade organizacional" />
            <Column field="ativa" header="Ativo" body={(rowData) => rowData.ativa ? "Sim" : "Não"} />
        </BaseListagem>
    );
}
